import Icon from '../../../helpers/components/Icon';
import addIcon from 'assets/svg/add-01.svg';
import { useState } from 'react';
import classNames from 'classnames';

const AddResourceButton = ({ children, title, onClick, active = false, classname = '' }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      className={classNames(classname)}
      style={{
        display: 'flex',
        textAlign: 'start',
        fontFamily: 'Ubuntu-R',
        fontSize: '15px',
        color: active ? 'var(--color-brand)' : 'var(--border-gray)',
        letterSpacing: '0.04rem',
        cursor: 'pointer',
        alignItems: 'center',
        textDecoration: isHovered ? 'underline' : 'none',
        position: 'relative',
      }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{ margin: '0 10px 0 0' }}>
        <Icon
          color={active ? 'var(--color-brand)' : 'var(--border-gray)'}
          src={addIcon}
          width={'12px'}
          height={'12px'}
        />
      </div>
      <span>{title}</span>
      {active && (
        <div
          style={{
            flexGrow: 1,
            height: '2px',
            backgroundColor: 'var(--color-brand)',
            margin: '0 10px',
          }}
        />
      )}
      {children}
    </div>
  );
};

export default AddResourceButton;
